import { z } from 'zod';
import { ResourceType } from '../../../../enumerations/ResourceType';
import {
    useMultiResourceSingleParentedResourceAdapterActions,
} from '../../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import { IdSchema } from '../../../../resource-base/baseSchemas';
import {
    defaultParentedPersistableResource,
    ParentedPersistableResourceSchema,
} from '../../../../resource-base/persistableResourceTypes';

export const SystemAnnouncementUserDismissalResourceSchema = ParentedPersistableResourceSchema.extend({
    user: IdSchema,
    resourceType: z.literal(ResourceType.SYSTEM_ANNOUNCEMENT_USER_DISMISSAL).default(ResourceType.SYSTEM_ANNOUNCEMENT_USER_DISMISSAL),
});

export type SystemAnnouncementUserDismissalResource = z.infer<typeof SystemAnnouncementUserDismissalResourceSchema>;

export const defaultSystemAnnouncementUserDismissalResource: SystemAnnouncementUserDismissalResource = {
    ...defaultParentedPersistableResource,
    resourceType: ResourceType.SYSTEM_ANNOUNCEMENT_USER_DISMISSAL,
    user: '',
};

export function useSystemAnnouncementUserDismissalActions() {
    return useMultiResourceSingleParentedResourceAdapterActions(
        'system/announcement-user-dismissal',
        ResourceType.SYSTEM_ANNOUNCEMENT_USER_DISMISSAL,
        SystemAnnouncementUserDismissalResourceSchema
    );
}
